import store from '@state/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/home')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => lazyLoadView(import('@views/dashboard')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/promotion',
    name: 'Promotion',
    component: () => lazyLoadView(import('@views/promotion/promotion')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editPromotion',
    name: 'editPromotion',
    component: () => lazyLoadView(import('@views/promotion/editPromotion')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/listAccounts',
    name: 'listAccounts',
    component: () => lazyLoadView(import('@views/cityLedger/listAccounts')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createAccount',
    name: 'createAccount',
    component: () => lazyLoadView(import('@views/cityLedger/createAccount')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editAccount',
    name: 'editAccount',
    component: () => lazyLoadView(import('@views/cityLedger/editAccount')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/listOrganizations',
    name: 'listOrganizations',
    component: () =>
      lazyLoadView(import('@views/cityLedger/listOrganizations')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createOrganization',
    name: 'createOrganization',
    component: () =>
      lazyLoadView(import('@views/cityLedger/createOrganization')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editOrganization',
    name: 'editOrganization',
    component: () => lazyLoadView(import('@views/cityLedger/editOrganization')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editSupplier',
    name: 'editSupplier',
    component: () =>
      lazyLoadView(import('@views/inventory/supplier/editSupplier')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/settleCityLedgerBill',
    name: 'settleCityLedgerBill',
    component: () =>
      lazyLoadView(import('@views/cityLedger/settleCityLedgerPayment')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/settleCityLedgerAccountPayment',
    name: 'SettleCityLedgerAccountPayments',
    component: () =>
      lazyLoadView(import('@views/cityLedger/settleCityLedgerAccountPayment')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/transactionDetailReport',
    name: 'Transaction Detail Report',
    component: () =>
      lazyLoadView(import('@views/cityLedger/transactionDetailReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createpo',
    name: 'createpo',
    component: () => lazyLoadView(import('@views/inventory/po/createNewPO')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/updatepo',
    name: 'updatepo',
    component: () => lazyLoadView(import('@views/inventory/po/updatePO')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/modiferItems',
    name: 'modiferItems',
    props: true,
    component: () => lazyLoadView(import('@views/item/newModifierItems')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createModiferItem',
    name: 'createModiferItem',
    props: true,
    component: () => lazyLoadView(import('@views/item/createModiferItem')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editModiferItem',
    name: 'editModiferItem',
    props: true,
    component: () => lazyLoadView(import('@views/item/editModiferItem')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/polist',
    name: 'polist',
    component: () => lazyLoadView(import('@views/inventory/po/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/posummary',
    name: 'posummary',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/po/summary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grnlist',
    name: 'grnlist',
    component: () => lazyLoadView(import('@views/inventory/grn/grnList')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/creategrn',
    name: 'creategrn',
    component: () => lazyLoadView(import('@views/inventory/grn/create')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createnewgrn',
    name: 'createnewgrn',
    component: () => lazyLoadView(import('@views/inventory/grn/createNewGRN')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/updategrn',
    name: 'updategrn',
    component: () => lazyLoadView(import('@views/inventory/grn/updateGRN')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grnsummary',
    name: 'grnsummary',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/grn/summary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grnsummarypage',
    name: 'grnsummarypage',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/grn/grnSummary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/issuenotelist',
    name: 'issuenotelist',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/issuenote/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createissuenote',
    name: 'createissuenote',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/issuenote/createNewIssueNote')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/updateissuenote',
    name: 'updateissuenote',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/issuenote/updateIssueNote')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/issuenotesummary',
    name: 'issuenotesummary',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/issuenote/summary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/supplierreturnlist',
    name: 'supplierreturnlist',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/supplierReturn/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createsupplierreturn',
    name: 'createsupplierreturn',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/supplierReturn/create')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createnewsupplierreturn',
    name: 'createnewsupplierreturn',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/supplierReturn/createNewSR')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/summarysupplierreturnpage',
    name: 'summarysupplierreturnpage',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/supplierReturn/srSummary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/supplierreturnsummary',
    name: 'supplierreturnsummary',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/supplierReturn/summary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/stockadjustmentlist',
    name: 'stockadjustmentlist',
    component: () =>
      lazyLoadView(import('@views/inventory/stockAdjustment/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createstockadjustment',
    name: 'createstockadjustment',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/stockAdjustment/createNewSA')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/updatestockadjustment',
    name: 'updatestockadjustment',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/stockAdjustment/updateSA')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/stockadjustmentsummary',
    name: 'stockadjustmentsummary',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/stockAdjustment/summaryNewSA')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/stockentrylist',
    name: 'stockentrylist',
    component: () => lazyLoadView(import('@views/inventory/stockEntry/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createstockentry',
    name: 'createstockentry',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/stockEntry/createNewSE')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/updatestockentry',
    name: 'updatestockentry',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/stockEntry/updateSE')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/stockentrysummary',
    name: 'stockentrysummary',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/stockEntry/seSummary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createINVrecipe',
    name: 'createINVrecipe',
    component: () =>
      lazyLoadView(import('@views/inventory/batchProcessing/newCreate')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/wastagemanagementlist',
    name: 'wastagemanagementlist',
    component: () =>
      lazyLoadView(import('@views/inventory/wastageManagement/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createwastagemanagement',
    name: 'createwastagemanagement',
    props: true,
    component: () =>
      lazyLoadView(
        import('@views/inventory/wastageManagement/createNewWastage')
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/updatewastagemanagement',
    name: 'updatewastagemanagement',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/wastageManagement/updateWastage')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/wastagesummarypage',
    name: 'wastagesummarypage',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/wastageManagement/wsSummary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/wastagemanagementsummary',
    name: 'wastagemanagementsummary',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/wastageManagement/summary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/transferoutlist',
    name: 'transferoutlist',
    component: () => lazyLoadView(import('@views/inventory/transferOut/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createtransferout',
    name: 'createtransferout',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/transferOut/create')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createnewtransferout',
    name: 'createnewtransferout',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/transferOut/createNewTransferOut')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: 'updatetransferout',
    name: 'updatetransferout',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/transferOut/updateTransferOut')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: 'transferoutsummarypage',
    name: 'transferoutsummarypage',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/transferOut/transferOutSummary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/transferoutsummary',
    name: 'transferoutsummary',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/transferOut/summary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/transferinlist',
    name: 'transferinlist',
    component: () => lazyLoadView(import('@views/inventory/transferIn/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createtransferin',
    name: 'createtransferin',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/transferIn/create')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createnewtransferin',
    name: 'createnewtransferin',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/transferIn/createNewTransferIn')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/transferinsummary',
    name: 'transferinsummary',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/transferIn/summary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/transferinsummarypage',
    name: 'transferinsummarypage',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/transferIn/transferInSummary')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/measuretypelist',
    name: 'measuretypelist',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/uom/measureTypeList')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/unitlist',
    name: 'unitlist',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/uom/unitList')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/categorylist',
    name: 'categorylist',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/category/categoryList')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/subcategorylist',
    name: 'subcategorylist',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/category/subCategoryList')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/inventoryitemlist',
    name: 'inventoryitemlist',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/itemManagement/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createinventoryitem',
    name: 'createinventoryitem',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/itemManagement/create')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/supplierlist',
    name: 'supplierlist',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/supplier/list')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createsupplier',
    name: 'createsupplier',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/supplier/create')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createrecipe',
    name: 'createrecipe',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/recipe/create')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/stocksummaryreport',
    name: 'stocksummaryreport',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/reports/stockSummaryReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/stockvaluationreport',
    name: 'stockvaluationreport',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/reports/stockValuationReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/grnlistingreport',
    name: 'grnlistingreport',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/reports/grnListingReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/stockvariancereport',
    name: 'stockvariancereport',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/reports/stockVarianceReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/stockusagereport',
    name: 'stockusagereport',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/reports/stockUsageReport')),
    meta: {
      authRequired: true,
    },
  },
  // {
  //   path: '/itempopup',
  //   name: 'itempopup',
  //   component: () => lazyLoadView(import('@components/itempopup')),
  //   meta: {
  //     authRequired: true,
  //   },
  // },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/auth/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          // next({
          //   name: 'home',
          // })
          next()
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          route => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? {
                name: 'home',
              }
            : {
                ...routeFrom,
              }
        )
      },
    },
  },
  {
    path: '/items',
    name: 'Items',
    component: () => lazyLoadView(import('@views/item/index')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editItem',
    name: 'editItem',
    props: true,
    component: () => lazyLoadView(import('@views/item/editItem')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createItem',
    name: 'createItem',
    props: true,
    component: () => lazyLoadView(import('@views/item/createItem')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createcategory',
    name: 'createcategory',
    component: () => lazyLoadView(import('@views/item/createCategory')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/userRole',
    name: 'userRole',
    component: () => lazyLoadView(import('@views/userManagement/userRole')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/user',
    name: 'user',
    component: () => lazyLoadView(import('@views/userManagement/user')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/salesReport',
    name: 'Sales Report',
    component: () => lazyLoadView(import('@views/reports/salesReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/productCategoryReport',
    name: 'Product Category Report',
    component: () => lazyLoadView(import('@views/reports/productReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/orderCancellationReport',
    name: 'Order Cancellation Report',
    component: () =>
      lazyLoadView(import('@views/reports/orderCancellationReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/paymentCancellationReport',
    name: 'Order Cancellation Report',
    component: () =>
      lazyLoadView(import('@views/reports/paymentCancellationReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/discountReport',
    name: 'Discount Report',
    component: () => lazyLoadView(import('@views/reports/discountReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/billWiseReport',
    name: 'Bill Wise Report',
    component: () => lazyLoadView(import('@views/reports/billWiseReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/customerReport',
    name: 'Customer Report',
    component: () => lazyLoadView(import('@views/reports/customerReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/discount',
    name: 'Discounts',
    component: () => lazyLoadView(import('@views/discount/discount')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/promotionlist',
    name: 'Promotions List',
    component: () => lazyLoadView(import('@views/promotion/promotionList.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/customPayment',
    name: 'Custom Payments',
    component: () => lazyLoadView(import('@views/customPayment/customPayment')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/tableRevenueReport',
    name: 'Table Revenue Report',
    component: () => lazyLoadView(import('@views/reports/tableRevenueReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/archivedSalesReport',
    name: 'Archived Sales Report',
    component: () =>
      lazyLoadView(import('@views/archivedReports/archivedSalesReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/archivedProductCategoryReport',
    name: 'Archived Product Category Report',
    component: () =>
      lazyLoadView(import('@views/archivedReports/archivedProductReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/archivedOrderCancellationReport',
    name: 'Archived Order Cancellation Report',
    component: () =>
      lazyLoadView(
        import('@views/archivedReports/archivedOrderCancellationReport')
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/archivedPaymentCancellationReport',
    name: 'Archived Payment Cancellation Report',
    component: () =>
      lazyLoadView(
        import('@views/archivedReports/archivedPaymentCancellationReport')
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/archivedDiscountReport',
    name: 'Archived Discount Report',
    component: () =>
      lazyLoadView(import('@views/archivedReports/archivedDiscountReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/listSystemSettings',
    name: 'listSystemSettings',
    props: true,
    component: () =>
      lazyLoadView(import('@views/systemSettings/listSystemSettings')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editSystemSettings',
    name: 'editSystemSettings',
    props: true,
    component: () =>
      lazyLoadView(import('@views/systemSettings/editSystemSettings')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/listCharges',
    name: 'listCharges',
    component: () => lazyLoadView(import('@views/charges/listCharges')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createCharges',
    name: 'createCharges',
    component: () => lazyLoadView(import('@views/charges/createCharges')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editCharges',
    name: 'editCharges',
    component: () => lazyLoadView(import('@views/charges/editCharges')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/listPrinter',
    name: 'listPrinter',
    component: () => lazyLoadView(import('@views/printer/listPrinter')),

    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createPrinter',
    name: 'createPrinter',
    component: () => lazyLoadView(import('@views/printer/createPrinter')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editPrinter',
    name: 'editPrinter',
    component: () => lazyLoadView(import('@views/printer/editPrinter')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editOutlet',
    name: 'editOutlet',
    component: () => lazyLoadView(import('@views/outlets/editOutlet')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/statics',
    name: 'statics',
    component: () => lazyLoadView(import('@views/statics')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/ccTaggingReport',
    name: 'ccTaggingReport',
    component: () => lazyLoadView(import('@views/reports/ccTaggingReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/comments',
    name: 'comments',
    component: () => lazyLoadView(import('@views/comments/comments')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/listFloor',
    name: 'listFloor',
    component: () => lazyLoadView(import('@views/floor/listFloor')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createFloor',
    name: 'createFloor',
    component: () => lazyLoadView(import('@views/floor/createFloor')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editFloor',
    name: 'editFloor',
    component: () => lazyLoadView(import('@views/floor/editFloor')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/taxlist',
    name: 'taxlist',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/tax/taxlist')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createTax',
    name: 'createTax',
    component: () => lazyLoadView(import('@views/inventory/tax/createTax')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/editTax',
    name: 'editTax',
    component: () => lazyLoadView(import('@views/inventory/tax/editTax')),
    props: route => ({
      ...route.params,
    }),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/recipeCostReport',
    name: 'recipeCostReport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/recipeCostReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/batchprocessCostReport',
    name: 'batchprocessCostReport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/batchProcessCostReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/profitMarginReport',
    name: 'profitMarginReport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/profitMarginReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/oloSystemSettings',
    name: 'oloSystemSettings',
    component: () =>
      lazyLoadView(import('@views/oloSettings/oloSystemSettings')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/olomenulist',
    name: 'OLO Menu List',
    component: () => lazyLoadView(import('@views/oloMenu/oloMenuList')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/checking',
    name: 'test',
    component: () => lazyLoadView(import('@views/oloMenu/checking')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/reset',
    name: 'resetpassword',
    component: () => lazyLoadView(import('@views/auth/resetPassword')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/issuenotelistingreport',
    name: 'issuenotelisingreport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/issueNoteListingReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/bulkPriceUpdate',
    name: 'priceupdate',
    component: () => lazyLoadView(import('@views/item/bulkPriceUpdate')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/transferinlistingreport',
    name: 'transferinlistingreport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/transferInListingReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/transferoutlistingreport',
    name: 'transferoutlistingreport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/transferOutListingReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/mergedBillsReport',
    name: 'mergedBillsReport',
    component: () => lazyLoadView(import('@views/reports/mergedBillReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/batchProcessReport',
    name: 'batchProcessReport',
    component: () =>
      lazyLoadView(
        import('@views/inventory/reports/batchProcessListingReport')
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/wastageNoteReport',
    name: 'wastageNoteReport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/wastageNoteListingReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/stockAdjustmentReport',
    name: 'stockAdjustmentReport',
    component: () =>
      lazyLoadView(
        import('@views/inventory/reports/stockAdjustmentListingReport')
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/stockEntryReport',
    name: 'stockEntryReport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/stockEntryListingReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/PoReport',
    name: 'PoReport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/poListingReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/SupplierReturnReport',
    name: 'SupplierReturnReport',
    component: () =>
      lazyLoadView(
        import('@views/inventory/reports/supplierReturnListingReport')
      ),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/RecipeItemListingReport',
    name: 'RecipeItemListingReport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/rawMaterialReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/SRNListingReport',
    name: 'SRNListingReport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/srnListingReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/userLogReport',
    name: 'User Log Report',
    component: () => lazyLoadView(import('@views/reports/userLogReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/notification',
    name: 'Notification',
    component: () => lazyLoadView(import('@views/userNotificationPanel')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/advancePaymentReport',
    name: 'Customer Report',
    component: () => lazyLoadView(import('@views/reports/advancePayment')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/menuItemReport',
    name: 'menuItemReport',
    component: () => lazyLoadView(import('@views/reports/menuItem')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/blocked',
    name: 'blocked',
    component: require('@views/blocklogin').default,
    // component: () => lazyLoadView(import('@views/blocklogin')),
  },
  {
    path: '/bulkBatchProcess',
    name: 'bulkBatchProcess',
    component: () =>
      lazyLoadView(import('@views/inventory/batchProcessing/runBatch')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/bulkStockEntry',
    name: 'bulkStockEntry',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/stockEntry/bulkStockEntry')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/costofsalesreport',
    name: '/costofsalesreport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/costOfSalesReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/itemTransactionReport',
    name: '/itemTransactionReport',
    component: () =>
      lazyLoadView(import('@views/inventory/reports/itemListingReport')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/itemCopy',
    name: '/itemCopy',
    component: () =>
      lazyLoadView(import('@views/inventory/copyOutlet/copyOutlet')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/srnlist',
    name: 'srnlist',
    component: () => lazyLoadView(import('@views/inventory/srn/list.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/createnewsrn',
    name: 'createnewsrn',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/srn/createSRN.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/updatesrn',
    name: 'updatesrn',
    props: true,
    component: () => lazyLoadView(import('@views/inventory/srn/updateSRN.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/srnsummarypage',
    name: 'srnsummarypage',
    props: true,
    component: () =>
      lazyLoadView(import('@views/inventory/srn/summarySRN.vue')),
    meta: {
      authRequired: true,
    },
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/loading').default,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/timeout').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 100000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
